export default (err: any): void => console.error(err)
